import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { NgxSpinnerModule } from 'ngx-spinner';
import { EliminarRolComponent } from '../eliminar-rol.component';

@Component({
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, CommonModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule,EliminarRolComponent],
  selector: 'app-dialog-delete-rol',
  templateUrl: './dialog-delete-rol.component.html',
  styleUrls: ['./dialog-delete-rol.component.css']
})
export class DialogDeleteRolComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
